import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from '../../types';
import AccountDetailsPage from './AccountDetailsPage';
import {
  dataCaptureSelectors,
  saveAboutYourForm,
  redirectToBusinessDetails,
  onAccountDetailsChange,
  onCountryRemove
} from '../../store/dataCapture';
import { ACCOUND_DETAILS } from '../../utils/constants';

const AccountDetailsSection = ({
  saveAboutYourForm,
  getBusinessData,
  onAccountDetailsChange,
  onCountryRemove
}) => {
  return (
    <AccountDetailsPage
      saveAboutYourForm={saveAboutYourForm}
      onAccountDetailsChange={onAccountDetailsChange}
      getBusinessData={getBusinessData}
      onCountryRemove={onCountryRemove}
    />
  );
};

AccountDetailsSection.propTypes = {
  saveAboutYourForm: PropTypes.func.isRequired
};

const actionCreators = {
  saveAboutYourForm,
  redirectToBusinessDetails,
  onAccountDetailsChange,
  onCountryRemove
};

const mapStateToProps = state => ({
  getBusinessData: dataCaptureSelectors.getBusinessData(state, ACCOUND_DETAILS)
});

const mapDispatchToProps = dispatch => bindActionCreators(actionCreators, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(AccountDetailsSection);
